import { ActiveOrder } from 'app/page/orders/model/active-order';

class ActiveOrdersMapper {
    public static mapActiveOrders(orders: OrderTrackerBackend.Order[]): Record<string, ActiveOrder> {
        return orders
            .map(ActiveOrdersMapper.mapActiveOrder)
            .reduce((acc, activeOrder) => ({ ...acc, [activeOrder.order.id!]: activeOrder }), {});
    }

    private static mapActiveOrder(order: OrderTrackerBackend.Order): ActiveOrder {
        return {
            order,
            initialized: false,
            pendingUpdate: false,
        };
    }
}

export { ActiveOrdersMapper };
